import { ArrowUpRight } from "lucide-react";
import topics from "@/data/publicationTopics.json";

const topicLabel = (id, lang) => topics.find((t) => t.id === id)?.[lang] || id;
const ExtLink = ({ href, children, testId }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className="inline-flex items-center gap-1 text-[#374F49] hover:text-[#1A2522] underline-offset-4 hover:underline">
    {children}
  </a>
);

export const PublicationItem = ({ item, lang, t }) => (
  <li className="py-7 border-b border-[#D3CEC4]/80 last:border-b-0" data-testid={`publication-${item.id}`}>
    <div className="flex flex-wrap items-center gap-2 text-[10px] tracking-[0.24em] uppercase font-semibold text-[#7A857F]">
      <span>{item.year}</span>
      {item.type !== "article" && <span className="px-2 py-0.5 rounded-full bg-[#EAE5D9] text-[#374F49]">{t[item.type]}</span>}
      {item.topics?.map((tp) => (
        <span key={tp} className="px-2 py-0.5 rounded-full border border-[#D3CEC4]">{topicLabel(tp, lang)}</span>
      ))}
    </div>
    <p className="mt-3 text-[14px] sm:text-[15px] leading-relaxed text-[#1A2522]" data-testid={`citation-${item.id}`}>{item.citation}</p>
    {item.url && (
      <div className="mt-2 text-[13px]">
        <ExtLink href={item.url} testId={`publication-link-${item.id}`}>
          {t.original} <ArrowUpRight className="w-3.5 h-3.5" />
        </ExtLink>
      </div>
    )}
  </li>
);

export const PublicationList = ({ items, lang, t, testId }) =>
  items.length ? (
    <ul data-testid={testId}>
      {items.map((it) => (
        <PublicationItem key={it.id} item={it} lang={lang} t={t} />
      ))}
    </ul>
  ) : (
    <p data-testid={`${testId}-empty`} className="py-8 text-[13px] text-[#7A857F] italic">{t.empty}</p>
  );
